// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Sales = [  
  {
    title: 'Ledger Followup',
    path: '/dashboard/manage/sales/ledger_followups',
    icon: icon('company', 'png'),
    ShortName: 'SalesFollowupPanel',
  },
  {
    title: 'Order Followup',
    path: '/dashboard/manage/sales/order_followups',
    icon: icon('company', 'png'),
    ShortName: 'OrderFollwUps',
  },
];

export default Sales;
